import React from 'react';
import { NavLink } from "react-router-dom";

const CoordinatorFooter = () => {
    return (
        <nav className="bottom-nav">
            <ul>
                <li>
                    <NavLink
                        to="/"
                        end
                        className={({isActive}) => (isActive ? "on" : "")}
                    >
                        <figure className="home"></figure>
                        <span className="ico home"></span>
                        <span>HOME</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/announcement"
                        className={({isActive}) => (isActive ? "on" : "")}
                    >
                        <span className="ico recruit"></span>
                        <span>내 공고</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink  to="/service-apply"
                              className={({isActive}) => (isActive ? "on" : "")}>
                        <span className="ico apply"></span>
                        <span>서비스 신청</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/wallet"
                        className={({isActive}) => (isActive ? "on" : "")}
                    >
                        <span className="ico wallet"></span>
                        <span>내 지갑</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/menu"
                        className={({isActive}) => (isActive ? "on" : "")}
                    >
                        <span className="ico allmenu"></span>
                        <span>전체메뉴</span>
                    </NavLink>
                </li>
            </ul>

        </nav>
    );
};

export default CoordinatorFooter;
